var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "has-logo": _vm.showLogo } },
    [
      _vm.showLogo
        ? _c("Logo", {
            attrs: { collapse: _vm.isCollapse, "is-liked": _vm.isLiked },
          })
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "toggle-sidebar-tool",
          on: { click: _vm.toggleSideBar },
        },
        [
          _c("i", {
            class: _vm.isCollapse
              ? "el-icon-arrow-right"
              : "el-icon-arrow-left",
          }),
        ]
      ),
      _c(
        "el-scrollbar",
        {
          attrs: { slot: "reference", "wrap-class": "scrollbar-wrapper" },
          slot: "reference",
        },
        [
          _c(
            "el-menu",
            {
              attrs: {
                "default-active": _vm.activeMenu,
                collapse: _vm.isCollapse,
                "background-color": _vm.variables.menuBg,
                "text-color": _vm.variables.menuText,
                "unique-opened": false,
                "active-text-color": _vm.variables.menuActiveText,
                "collapse-transition": false,
                mode: "vertical",
              },
            },
            _vm._l(_vm.leftMenuRoutes, function (route, index) {
              return _c("SidebarItem", {
                key: route.path + index,
                attrs: { item: route, "base-path": route.path },
              })
            }),
            1
          ),
        ],
        1
      ),
      _c("HoverItem", {
        attrs: { "liked-data": _vm.LIKED_DATA, "is-liked": _vm.isLiked },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }